import { ErrorReportingUtils } from '@mm/plugins';
import { forEach, uniqueId } from 'lodash';
import { SYNC_TIME } from '../constants/sync';
import APIMapController from './APIMapController';
import changesQuequeInstance from './ChangesQueue';

class SyncManager {
  constructor(changesQueque) {
    this.changesQueque = changesQueque;
    this.proccessingPromises = [];
    this.success = [];
    this.errors = [];
    this.syncing = false;
    this.timeoutHandle = 0;

    this.onStartProcessing = {};
    this.onFinishProcessing = {};
    this.onErrorAcquired = [];

    this.changesQueque.registerOnAddHandler(this.onAddToQueue);
  }

  sync = () => {
    if (this.changesQueque.isEmpty()) {
      this.syncWithTimeout();
      return;
    }
    const changes = this.changesQueque.getAllChanges();
    const proccessingPromises = changes.map(change =>
      APIMapController.perform(change),
    );

    this.proccessingPromises.push(...proccessingPromises);
    proccessingPromises.forEach(p =>
      p.then(this.handleSuccessChange).catch(this.handleFailedChange),
    );
  };

  syncWithTimeout = () => {
    if (this.isSyncCycleFinished()) {
      this.timeoutHandle = setTimeout(this.sync, this.timeoutTime);
    }
  };

  startSync(timeout = 1000) {
    this.timeoutTime = timeout;
    this.timeoutHandle = setTimeout(this.sync, timeout);
    this.syncing = true;
  }

  stopSync() {
    clearTimeout(this.timeoutHandle);
    this.syncing = false;
  }

  handleFailedChange = error => {
    this.errors.push(error);

    ErrorReportingUtils.reportError('SyncManager error', {
      extraData: { error },
    });

    this.onErrorAcquired.forEach(listener => listener(error));

    this.syncWithTimeout();
    this.clearQueue();
  };

  handleSuccessChange = change => {
    this.success.push(change);
    this.syncWithTimeout();
    this.clearQueue();
  };

  isSyncCycleFinished() {
    return (
      this.proccessingPromises.length ===
      this.errors.length + this.success.length
    );
  }

  clearQueue = () => {
    if (this.isSyncCycleFinished()) {
      this.success = [];
      this.errors = [];
      this.proccessingPromises = [];
      forEach(this.onFinishProcessing, a => a());
    }
  };

  onAddToQueue = () => {
    if (this.changesQueque.length === 1) {
      forEach(this.onStartProcessing, a => a());
    }
    clearTimeout(this.timeoutHandle);

    this.timeoutHandle = setTimeout(this.sync, this.timeoutTime);
  };

  registerOnFinishProcessing = func => {
    const SUBSCRIBER_ID = uniqueId();
    this.onFinishProcessing[SUBSCRIBER_ID] = func;

    return () => {
      delete this.onFinishProcessing[SUBSCRIBER_ID];
    };
  };

  registerOnStartProcessing = func => {
    const SUBSCRIBER_ID = uniqueId();
    this.onStartProcessing[SUBSCRIBER_ID] = func;

    return () => {
      delete this.onStartProcessing[SUBSCRIBER_ID];
    };
  };

  registerOnErrorAcquired = func => this.onErrorAcquired.push(func);
}

const syncManager = new SyncManager(changesQuequeInstance);
syncManager.startSync(SYNC_TIME);

export default syncManager;
